import type {SxProps, Theme} from '@mui/material';
import {COLORS} from '../../style/colors-ts';

export const tabsColors = ['default', 'primary', 'secondary'] as const;

export type TabsColor = typeof tabsColors[number];

const tabsColorTokens: Record<TabsColor, {selected: string; indicator: string}> = {
    default: {
        selected: COLORS.grey[700],
        indicator: COLORS.grey[500],
    },
    primary: {
        selected: COLORS.primary.main,
        indicator: COLORS.primary[500],
    },
    secondary: {
        selected: COLORS.secondary.main,
        indicator: COLORS.secondary[500],
    },
};

export const getTabsSx = (color: TabsColor = 'default'): SxProps<Theme> => {
    const tokens = tabsColorTokens[color];

    return {
        '& .MuiTabs-indicator': {
            backgroundColor: tokens.indicator,
        },
        '& .MuiTab-root': {
            color: COLORS.grey[500],
            '&.Mui-selected': {
                color: tokens.selected,
            },
            '&.Mui-disabled': {
                color: COLORS.grey[300],
            },
        },
    };
};
